import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface GradeTextSettings {
    grade: 'A' | 'B' | 'C' | 'D';
    discount: number;
    description: string;
}

export const defaultSettings: GradeTextSettings[] = [
    { grade: 'A', discount: 30, description: 'מוצר איכותי במצב מושלם, באריזה מקורית ובמצב חדש לחלוטין' },
    { grade: 'B', discount: 45, description: 'מוצר במצב טוב, עשוי להיות ללא אריזה מקורית אך תקין לחלוטין. ללא אחריות או החזרה.' },
    { grade: 'C', discount: 70, description: 'מוצר נמכר במצבו הנוכחי, ללא אחריות או החזרה' },
    { grade: 'D', discount: 85, description: 'מכירה סופית, המוצר עשוי להיות עם פגמים קוסמטיים, ללא אחריות או החזרה' },
];

export const useGradeSettings = () => {
    const [settings, setSettings] = useState<GradeTextSettings[]>(defaultSettings);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const { data, error } = await supabase
                .from('site_settings')
                .select('key, value')
                .like('key', 'grade_%');

            if (error) throw error;

            if (data && data.length > 0) {
                setSettings(prev => prev.map(setting => {
                    const discountKey = `grade_${setting.grade}_discount`;
                    const descriptionKey = `grade_${setting.grade}_description`;

                    const discountVal = data.find(d => d.key === discountKey)?.value;
                    const descriptionVal = data.find(d => d.key === descriptionKey)?.value;

                    return {
                        ...setting,
                        discount: discountVal ? parseFloat(discountVal) : setting.discount,
                        // If DB has value, use it. If not, fallback to default. 
                        // Note: If you want to support legacy footerText migration, you could check that key here too.
                        description: descriptionVal !== undefined ? descriptionVal : setting.description,
                    };
                }));
            }
        } catch (error) {
            console.error('Error loading grade settings:', error);
        } finally {
            setLoading(false);
        }
    };

    const getGradeSettings = (grade: string) => {
        return settings.find(s => s.grade === grade);
    };

    return { settings, loading, getGradeSettings, refresh: fetchSettings };
};
